import { FC } from 'react';
import Highlighter from 'react-highlight-words';
import cn from 'classnames';
import { ElementThemeUnion } from 'constants/routes';
import { ReactComponent as MinusIcon } from 'images/newIcons/minus.svg';
import { ReactComponent as PlusIcon } from 'images/newIcons/plus.svg';

interface OptionProps {
  option: { label: string; value: number };
  onToggle: () => void;
  searchQuery: string;
  isAdded: boolean;

  theme?: ElementThemeUnion;
}

const Option: FC<OptionProps> = ({
  option,
  onToggle,
  searchQuery,
  isAdded,
  theme = 'light',
}) => {
  const backgroundClass = theme === 'light' ? 'bg-light' : 'bg-ultrablack';
  const hoverClass = theme === 'light' ? 'hover:bg-dark' : 'hover:bg-light';
  const iconClass =
    'w-4 h-4 text-tpg_base opacity-0 group-hover:opacity-100 transition-opacity duration-200';

  return (
    <div
      className={cn(
        'w-full flex transition-colors duration-200 ease-in-out px-4 py-2 group',
        hoverClass,
        backgroundClass
      )}
      onClick={onToggle}
    >
      <span
        className={cn('flex-grow', {
          'text-bright_product': isAdded,
          'text-tpg_base': !isAdded,
        })}
      >
        <Highlighter
          searchWords={searchQuery ? [searchQuery] : []}
          textToHighlight={option.label}
          highlightClassName="highlighted tpg-c2"
          unhighlightClassName="unhighlighted uppercase break-all tpg-c2"
          autoEscape={true}
        />
      </span>
      {isAdded ? (
        <MinusIcon className={iconClass} />
      ) : (
        <PlusIcon className={iconClass} />
      )}
    </div>
  );
};

export default Option;
